import React, { Component } from "react";
import "./AccountList.scss";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import Flag from "semantic-ui-react/dist/es/elements/Flag";
import { ReactComponent as UpIcon } from "../../../../../assets/svg/up-arrow.svg";
import { ReactComponent as CuraCao } from "../../../../../assets/svg/curacao.svg";
import { ReactComponent as BonaireIcon } from "../../../../../assets/svg/bonaire.svg";
import { ReactComponent as GlobeIcon } from "../../../../../assets/svg/globe-icon.svg";
import { ReactComponent as Guernsey } from "../../../../../assets/svg/guernsey.svg";
import { ReactComponent as Isleofman } from "../../../../../assets/svg/Isleofman.svg";
import { ReactComponent as Bostonian } from "../../../../../assets/svg/bostonian.svg";
import { ReactComponent as UnknownFlag } from "../../../../../assets/svg/unknown-flag.svg";
import { ReactComponent as SintMarteen } from "../../../../../assets/svg/sint-maarten.svg";
import { ReactComponent as SouthSudan } from "../../../../../assets/svg/South-Sudan.svg";
import { ReactComponent as Jersey } from "../../../../../assets/svg/jersey.svg";
import { ReactComponent as SaintBarthelemy } from "../../../../../assets/svg/Saint-Barthelemy.svg";
import { ReactComponent as NoAccount } from "../../../../../assets/svg/no-account.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/svg/delete.svg";
import { Scrollbars } from "react-custom-scrollbars";

export default class AccountList extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.accountDivEnd = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.accountListData.length !== this.props.accountListData.length) {
            this.scrollAccountToBottom();
        }
    }

    customFlagRenderer = (name) => {
        if (name === "Curacao") {
            return (
                <span>
                    <CuraCao className="custom-icon" />
                </span>
            );
        } else if (name === "Bonaire, Sint Eustatius and Saba") {
            return (
                <span>
                    <BonaireIcon className="custom-icon" />
                </span>
            );
        } else if (name === "Guernsey") {
            return (
                <span>
                    <Guernsey className="custom-icon" />
                </span>
            );
        } else if (name === "Jersey") {
            return (
                <span>
                    <Jersey className="custom-icon" />
                </span>
            );
        } else if (name === "Isle of Man") {
            return (
                <span>
                    <Isleofman className="custom-icon" />
                </span>
            );
        } else if (name === "Millennium Bostonian") {
            return (
                <span>
                    <Bostonian className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Martin") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Sint Maarten") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Barthelemy") {
            return (
                <span>
                    <SaintBarthelemy className="custom-icon" />
                </span>
            );
        } else if (name == "Worldwide") {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        } else if (name === "South Sudan") {
            return (
                <span>
                    <SouthSudan className="custom-icon" />
                </span>
            );
        } else if (name == "Unknown") {
            return (
                <span>
                    <UnknownFlag className="custom-icon" />
                </span>
            );
        } else {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        }
    };

    scrollAccountToBottom = () => {
        this.accountDivEnd.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    };

    getCountryById = (_countryId) => {
        try {
            let countries = this.props.allLocations || [];
            if (countries.length > 0) {
                let countryInfo = countries.filter((x) => x.short_name.toLowerCase() === _countryId.toLowerCase());
                return countryInfo[0].name;
            } else return "";
        } catch (exp) {
            return "";
        }
    };
    getCountryCode = (_countryId) => {
        try {
            let countries = this.props.allLocations || [];
            let countryInfo = countries.filter((x) => x.short_name === _countryId);
            if (countryInfo.length > 0) return countryInfo[0].short_name.toLowerCase();
            else return "";
        } catch (exp) {
            return "";
        }
    };
    deleteAccount = (ind) => {
        this.props.deleteAccount(ind);
    };

    flagRenderer = (item) => <Flag className="flag_icon" name={item} />;

    render() {
        let fbCommentsList = [];
        let flagMissingCountries = [
            "Curacao",
            "Bonaire, Sint Eustatius and Saba",
            "Guernsey",
            "Isle of Man",
            "Millennium Bostonian",
            "Jersey",
            "Saint Martin",
            "Sint Maarten",
            "Worldwide",
            "South Sudan",
            "Saint Barthelemy",
            "Unknown",
        ];
        return (
            <div className="accountList">
                <div className="accounts__table-header">
                    <div className="post__url">Account Name/ URL Feeds </div>
                    <div className="country__name">Platform </div>
                    <div className="location">Location</div>
                    <span className="fetch__once">Entity Type </span>
                    <span className="delete__action">
                        <span className="delete-text-align">Delete</span>
                    </span>
                </div>
                {this.props.accountListData.length > 0 && (
                    <Scrollbars autoHide>
                        <div className="accounts__table-body">
                            {this.props.accountListData.map((elem, ind) => {
                                return (
                                    <div className="table__row" key={ind}>
                                        <div className="post__url">
                                            {elem.platform_name === "youtube" ? (elem.youtube_url ? elem.youtube_url : elem.account_name) : elem.account_name}
                                            {/* {elem.account_name + elem.platform_name === "youtube" ? (elem.youtube_url ? " " + elem.youtube_url : "") : ""} */}
                                        </div>
                                        <div className="country__name">
                                            {/* {["fbcomment", "facebook_post"].includes(elem.platform_name) ? "Facebook" : elem.platform_name} */}
                                            {elem.platform_name === "fbcomment" ? "FB Comments" : elem.platform_name === "twitter" ? "X" : elem.platform_name}
                                        </div>
                                        <div className="location">
                                            {flagMissingCountries.includes(this.getCountryById(elem.country))
                                                ? this.customFlagRenderer(this.getCountryById(elem.country))
                                                : this.flagRenderer(this.getCountryCode(elem.country))}
                                            {this.getCountryById(elem.country)}
                                        </div>
                                        <span className="fetch__once">{elem.entity_sub_type}</span>
                                        <span className="delete__action">
                                            <span
                                                className={`delete-comment`}
                                                onClick={() => {
                                                    this.deleteAccount(ind);
                                                }}>
                                                <DeleteIcon />
                                            </span>
                                        </span>
                                    </div>
                                );
                            })}
                            <div ref={this.accountDivEnd}></div>
                        </div>
                    </Scrollbars>
                )}

                {this.props.fbCommentsListLoading && (
                    <div className="list-loading">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                )}
                {this.props.accountListData.length == 0 && (
                    <div className="no-data">
                        {" "}
                        <NoAccount />
                        <p>No Account Added yet</p>
                    </div>
                )}
            </div>
        );
    }
}
